import { useCallback, useEffect, useState } from 'react';
import { supabase } from '@/src/lib/supabase';
import type { VenueSetupFields } from '@/src/components/dashboard/finish-venue-setup';

export function useVenueSetupFields(venueId: string | undefined) {
  const [fields, setFields] = useState<VenueSetupFields | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    // No venue yet: skip the query rather than asking for id = undefined.
    if (!venueId) { setFields(null); setLoading(false); return; }
    const { data } = await supabase
      .from('venues')
      .select('cuisine, address, suburb, state, postcode, phone, email, website_url, opening_hours, nearby_stops, latitude, longitude')
      .eq('id', venueId)
      .maybeSingle();
    setFields((data as VenueSetupFields) ?? null);
    setLoading(false);
  }, [venueId]);

  useEffect(() => { void refresh(); }, [refresh]);

  return { fields, loading, refresh };
}